import React, { useState } from "react";
 import "./CompanyTabs.css";
import SalesDashboard from "./SalesDashboard";
import SalesEnquiries from "./SalesEnquiries";
import SalseQuotation from "./SalseQuotation";
import SalesPipeline from "./SalesPipeline";
import SalseClients from "./SalseClients";
import SalesTeam from "./SalesTeam";
import Salsecommtionsectting from "./Salsecommtionsectting.jsx";
import SalesReports from "./SalesReports.jsx";
import PurchaseOrders from "../SalesManagment/PurchaseOrders.jsx";
const DummySection = ({ title }) => {
  return (
    <div className="dummy-box">
      <h2>{title}</h2>
      <p>This is a dummy section for <strong>{title}</strong>.</p>
      <span>Content will be added later 🚧</span>
    </div>
  );
};

const Company = () => {

   const tabs = [
      { id: 2, name: "Dashboard", component: () => <SalesEnquiries title="Dashboard" /> },
    { id: 7, name: "Sourcing", component: () => <Salsecommtionsectting title="Sourcing" /> },
    { id: 1, name: "Enquiries", component: () => <SalesDashboard title="Dashboard" /> },
  
    { id: 3, name: "Quotation Approval", component: () => <SalseQuotation title="Quotations" /> },
    // { id: 4, name: "Pipeline", component: () => <SalesPipeline title="Pipeline" /> },
    { id: 5, name: "Clients", component: () => <SalseClients title="Clients" /> },
    { id: 10, name: "Purchase Orders", component: () => <PurchaseOrders title="Purchase Orders" /> },
    { id: 6, name: "Projects", component: () => <SalesTeam title="Sales Team" /> },
   
    { id: 8, name: "Performance", component: () => <SalesReports title="Reports" /> }
  ];

  const [activeTab, setActiveTab] = useState(tabs[0].id);

  const ActiveComponent =
    tabs.find((tab) => tab.id === activeTab)?.component;

  return (
    <div className="cm-company-container">

      {/* Tabs */}
      <div className="cm-tabs-wrapper">
        <div className="cm-tabs-scroll">
          <div className="cm-tabs-row">

            {tabs.map((tab) => (
              <button
                key={tab.id}
                className={`cm-tab-btn ${
                  activeTab === tab.id ? "cm-tab-active" : ""
                }`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.name}
              </button>
            ))}

          </div>
        </div>
      </div>

      {/* Active Component */}
      <div className="cm-tab-content">
        {ActiveComponent && <ActiveComponent />}
      </div>

    </div>
  );
};

export default Company;